import {observer} from 'mobx-react';
import {InputError, PanelTooltip, TimeInput} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';
import {types} from 'main/tools';
import moment from 'moment';
import LocationIcon from './LocationIcon';

const StartTime = observer(({model, uiState}) => {
  if (model._type === types.HOLIDAY) {
    return <div className='bold'>{model.name}</div>;
  }

  if (model._type === types.TIME_OFF.ABSENCE) {
    return <div>{uiState.typeNameById(String(model.typeId))}</div>;
  }

  if (uiState.cannotCreateOrEdit(model)) {
    return (
      <div className='flex align-items-middle justify-between'>
        <span>{model.startTimeString}</span>
        <LocationIcon clockEvent={model.clockInEvent} uiState={uiState} />
      </div>
    );
  }

  return (
    <div className='flex align-items-middle justify-between'>
      <div className='relative'>
        <TimeInput
          key={uiState.inputKeyFor(model)}
          className={uiState.startTimeChangedSinceApproval(model) && 'bg-caution'}
          initialValue={model.startTimeString}
          disabled={!!model.manuallyEnteredHours}
          onFormat={({value, error}) => (!error && value !== model.startTimeString) && uiState.updateEntry(model, {startTimeString: value})}
          errorMessage={model.errors.startTime}
          style={uiState.startTimeChangedSinceApproval(model) ? {paddingRight: '1.5rem'} : {}}
        />
        {uiState.startTimeChangedSinceApproval(model) &&
          <div className='absolute' style={{lineHeight: 0, top: '11px', right: '8px'}}>
            <PanelTooltip>
              {model.approvedStartTime ?
                <div style={{lineHeight: 1}}>
                  <div className='pb2'>
                    <FormattedMessage id={'time_tracking.timesheet.EDITED_AFTER_APPROVAL'}/>
                  </div>
                  <div>
                    <FormattedMessage id={'time_tracking.timesheet.PREVIOUS_VALUE'}
                                      values={{time: <span className='bold'>{moment(model.approvedStartTime).utc().format(t('components.dates.TIMESTAMP_FORMAT'))}</span>}}/>
                  </div>
                </div> :
                <div style={{lineHeight: 1.42857143}}>
                  <FormattedMessage id={'time_tracking.timesheet.ADDED_AFTER_APPROVAL'}/>
                </div>
              }
            </PanelTooltip>
          </div>
        }
        {(model.saveStatus === 'saved' || model.saveStatus === 'fadingAway') && <div className={`h6 jumbo absolute ${model.saveStatus === 'fadingAway' ? 'fade-away' : ''}`}>
          <FormattedMessage id='time_tracking.timesheet.Saved'/>
        </div>}
        <InputError style={{padding: 0}} message={model.errors.base}/>
      </div>
      <LocationIcon clockEvent={model.clockInEvent} uiState={uiState} />
    </div>
  );
});

export default StartTime;
